/** Figma PEZ row metrics (node 113-7446 / 114-8833). */
export const PEZ_EFFECTS_VIEW_WIDTH = 308
export const PEZ_EFFECTS_LIST_WIDTH = 295
export const PEZ_EFFECTS_SCROLLBAR_GUTTER = PEZ_EFFECTS_VIEW_WIDTH - PEZ_EFFECTS_LIST_WIDTH
export const PEZ_EFFECTS_LIST_RADIUS = 6

export const PEZ_ROW_GAP = 4
export const PEZ_ROW_PADDING_X = 8
export const PEZ_EYE_BUTTON_SIZE = 32
export const PEZ_FX_LABEL_MIN_WIDTH = 73
export const PEZ_SLIDER_WIDTH = 110
export const PEZ_INPUT_WIDTH = 52

/** Content width inside row horizontal padding (295 − 16). */
export const PEZ_ROW_CONTENT_WIDTH = PEZ_EFFECTS_LIST_WIDTH - PEZ_ROW_PADDING_X * 2

export const PEZ_BINARY_ROW_HEIGHT = 44
export const PEZ_BINARY_ROW_PADDING_Y = 6
export const PEZ_ADJUSTABLE_ROW_HEIGHT = 56
export const PEZ_ADJUSTABLE_ROW_PADDING_Y = 12

/** Default “effects in view” height — 7 binary rows + partial 8th (Figma 113-7446). */
export const PEZ_EFFECTS_VIEW_DEFAULT_HEIGHT = 342
/** @deprecated Use PEZ_EFFECTS_VIEW_DEFAULT_HEIGHT */
export const PEZ_EFFECTS_VIEW_HEIGHT = PEZ_EFFECTS_VIEW_DEFAULT_HEIGHT
/** Minimum list viewport — ~3 binary rows. */
export const PEZ_EFFECTS_VIEW_MIN_HEIGHT = PEZ_BINARY_ROW_HEIGHT * 3
export const PEZ_EFFECTS_LIST_RESIZE_HANDLE_HEIGHT = 12

export const FIGMA_INPUT_SHADOW = '0px 1px 2px rgba(0, 0, 0, 0.05)'
// FLAG for whoever owns this file: confirmed directly in Figma (Drop Cap panel inspector, base/
// foreground swatch) that the `base/foreground` token is #0A0A0A, not #1E1902 — see
// `--base-foreground` in `src/index.css` and the drop-cap panel work that corrected it there and in
// the three layout dialogs that referenced it. This constant's name (`FIGMA_TEXT_PRIMARY`) strongly
// suggests it's meant to BE that same base/foreground token, which would make #1E1902 wrong here
// too — but this file/feature belongs to someone else and wasn't touched as part of that fix.
// Worth double-checking against Figma before relying on it further.
export const FIGMA_TEXT_PRIMARY = '#1E1902'
/** base/foreground — inactive row label + eye icon (WMPCM-11851). */
export const FIGMA_TEXT_FOREGROUND = '#0A0A0A'
/** base/muted-foreground — inactive numeric input text (WMPCM-11851). */
export const FIGMA_TEXT_MUTED = '#737373'

/**
 * Figma adjustable row grid — fixed columns so every slider/input shares the same x.
 * eye 32 | Fx label 73 (left-aligned text) | slider 110 | input 52
 */
export const PEZ_ADJUSTABLE_ROW_GRID = `32px ${PEZ_FX_LABEL_MIN_WIDTH}px ${PEZ_SLIDER_WIDTH}px ${PEZ_INPUT_WIDTH}px`

export const PEZ_BINARY_ROW_GRID = `32px minmax(0, 1fr)`
